import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20home%20theater%20setup%20with%20large%20projector%20screen%20displaying%20colorful%20movie%20thumbnails%2C%20warm%20golden%20ambient%20lighting%2C%20cozy%20luxurious%20living%20room%20with%20comfortable%20seating%2C%20abstract%20geometric%20patterns%2C%20soft%20glow%20atmosphere%2C%20elegant%20interior%20design%2C%20cinematic%20mood%20photography&width=1600&height=900&seq=hero-bg-2025-01&orientation=landscape"
          alt="看片网站推荐2025 - 精选在线观影平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-[900px] mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight mb-6">
            看片网站推荐2025
            <br />
            <span className="text-primary-400">高清资源一站直达</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-[650px] mx-auto mb-10 leading-relaxed">
            精选2025年最受欢迎的看片网站合集，涵盖高清电影、热播剧集、综艺纪录片等海量资源。
            无论你想找免费还是付费的看片网站，这里均有详细测评与安全访问指南。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/free-platforms"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              免费平台推荐
            </Link>
            <Link
              to="/category/paid-platforms"
              className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 font-semibold text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              查看最新测评
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-[800px] mx-auto">
            {[
              { num: '200+', label: '平台测评' },
              { num: '50+', label: '分类专题' },
              { num: '100万+', label: '月访问用户' },
              { num: '98%', label: '用户满意度' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading mb-1">
                  {stat.num}
                </div>
                <div className="text-xs md:text-sm text-white/60">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}